module.exports = __webpack_public_path__ + "static/img/AboutImgOne.8d426c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/AboutImgOne.png
// module id = OUjd
// module chunks = 1